import {Language, Page} from "../../views/types";
import React, {createContext, Dispatch, useReducer} from "react";

export enum ActionType {
    language,
    page
}

export interface ActionState {
    language: Language,
    page: Page,
    lastPage: Page
}

const initialActionState: ActionState = {
    language: Language.en,
    page: Page.unknown,
    lastPage: Page.unknown,
}

interface Action {
    type: ActionType,
    value?: any
}

function reducer(state: ActionState, action: Action) {
    const {type, value} = action
    switch (type) {
    case ActionType.language:
        return {
            ...state,
            language: value,
        }

    case ActionType.page:
        return {
            ...state,
            lastPage: state.page,
            page: value,
        }
    default:
        return state
    }
}

export const ActionContext = createContext<{
    actionState: ActionState,
    dispatchActionState: Dispatch<Action>
}>({
    actionState: initialActionState,
    dispatchActionState: () => null,
})

export function ActionProvider({children}: any) {
    const [actionState, dispatchActionState] = useReducer(reducer, initialActionState)
    return (
        <ActionContext.Provider value={{actionState, dispatchActionState}}>
            {children}
        </ActionContext.Provider>
    )
}
